import { Button } from 'react-bootstrap';
import { useApp } from '../../../hook/app.hook';
import { I18nKey } from '../../../i18n/i18n.key';
import { useTranslation } from 'react-i18next';
import { useWindow } from '../../../util/window-helper';
import { memo } from 'react';
import { Question, Section } from '../../../response/test.response';

const PreviousNextComponent = () => {
  const { t } = useTranslation();
  const {
    testRes,
    moveNext,
    movePrevious,
    updateActiveSection,
    updateActiveQuestion,
  } = useApp();

  const { isMobile } = useWindow();

  const section = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];

  const activeQuestionIndex = section.questionList.filter(
    (question: Question) => question.active,
  )[0].index;

  const currentSectionIndex = testRes.sectionList.findIndex(
    (section: Section) => section.active,
  );

  const handlePrevious = () => {
    // If not the first question in current section, use normal movePrevious
    if (activeQuestionIndex > 1) {
      movePrevious();
    } else {
      // If first question of current section
      if (currentSectionIndex > 0) {
        // Go to previous section's last question
        const previousSection = testRes.sectionList[currentSectionIndex - 1];
        updateActiveSection(previousSection.id);
        // Set the last question as active
        const lastQuestionId =
          previousSection.questionList[previousSection.questionList.length - 1]
            .id;
        updateActiveQuestion(lastQuestionId);
      } else {
        // If first section, go to last section's last question (rotation)
        const lastSection = testRes.sectionList[testRes.sectionList.length - 1];
        updateActiveSection(lastSection.id);
        const lastQuestionId =
          lastSection.questionList[lastSection.questionList.length - 1].id;
        updateActiveQuestion(lastQuestionId);
      }
    }
  };

  const handleNext = () => {
    // If not the last question in current section, use normal moveNext
    if (activeQuestionIndex < section.questionList.length) {
      moveNext();
    } else {
      // If last question of current section
      if (currentSectionIndex < testRes.sectionList.length - 1) {
        // Go to next section's first question
        const nextSection = testRes.sectionList[currentSectionIndex + 1];
        updateActiveSection(nextSection.id);
        // Set the first question as active
        const firstQuestionId = nextSection.questionList[0].id;
        updateActiveQuestion(firstQuestionId);
      } else {
        // If last section, go to first section's first question (rotation)
        const firstSection = testRes.sectionList[0];
        updateActiveSection(firstSection.id);
        const firstQuestionId = firstSection.questionList[0].id;
        updateActiveQuestion(firstQuestionId);
      }
    }
  };

  // Helper functions to determine button text
  const getPreviousButtonText = () => {
    if (activeQuestionIndex === 1) {
      // First question of section
      return 'Previous Section';
    }
    return t(I18nKey.PREVIOUS_TEXT);
  };

  const getNextButtonText = () => {
    if (activeQuestionIndex === section.questionList.length) {
      // Last question of section
      return 'Next Section';
    }
    return t(I18nKey.NEXT_TEXT);
  };

  return (
    <>
      {isMobile ? (
        <div className="d-flex align-items-center justify-content-between py-2 px-3 w-100">
          <Button
            onClick={handlePrevious}
            variant="outline-primary"
            className="ft-14 py-2 px-3 d-flex align-items-center font-weight-600 border-levenderblue rounded-25 previous-qs-m--btn"
          >
            <img src="/images/left-arrow.svg" className="me-2" alt="" />
            {getPreviousButtonText()}
          </Button>
          <Button
            onClick={handleNext}
            variant="outline-primary"
            className="ft-14 py-2 px-3 d-flex align-items-center font-weight-600 border-levenderblue rounded-25 next-qs-m--btn"
          >
            {getNextButtonText()}
            <img src="/images/end-arrow.svg" className="ms-3" alt="" />
          </Button>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-end prev-next-q-s--wrapper">
          <Button
            onClick={handlePrevious}
            variant="light"
            className="ft-14 py-2 px-3 d-flex align-items-center justify-content-center font-weight-600 border-levenderblue previous-qs--btn"
          >
            {getPreviousButtonText()}
          </Button>
          <Button
            onClick={handleNext}
            variant="success"
            className="ft-14 py-2 px-3 d-flex align-items-center justify-content-center font-weight-600 border-levenderblue next-qs--btn"
          >
            {getNextButtonText()}
          </Button>
        </div>
      )}
    </>
  );
};

export default memo(PreviousNextComponent);
